module.exports = __webpack_public_path__ + "img/shared10.8bd1f702.png";